module.exports = __webpack_public_path__ + "static/media/dz.25f0fd75.svg";